import React from "react";
import {connect} from "react-redux";

import '../YearToDateTableV2.scss';

import {ACTIVE_ADVISORY, ACTIVE_PLUS, MUTUAL_FUND, isPershingAccount} from 'services/Products';
import {Link} from "react-router-dom";
import {activePlusAccountUrl, planningDetailsUrl} from 'services/Externals';

const AccountInfo = ({ agreement, isRetirementAdvisoryServiceClient, isCWV = false, uberId = false }) => {
    const { agreementKey, agreementName, agreementNumberDisplay, positions } = agreement;
    const { agreementID, productType} = agreementKey;
    const agreementType = productType.enumerationID;

    const accountLinkClass = 'account-name-link b-typography-sans-serif--headline--50 b-font-weight-bold b-color-text--set--blue-3';

    return (
      <div className="account-info">
        {!isPershingAccount(agreementType) && (
          <div className="account-info-ticker b-typography-sans-serif--caption--200 b-font-weight-bold b-color-text--set--navy">
            {positions[0].ticker}
          </div>
        )}
        <div className="account-info-name">
          {agreementType === MUTUAL_FUND ? (
            <Link
              className={accountLinkClass}
              to={`/account-details?id=${agreementID}`}>
              {agreementName}
            </Link>
          ) : agreementType === ACTIVE_PLUS ? (
            <a
              className={accountLinkClass}
              href={activePlusAccountUrl(
                `${agreementID}`,
                isCWV,
                uberId,
                false
              )}>
              {agreementName}
            </a>
          ) : // RAS Client
          agreementType === ACTIVE_ADVISORY &&
            isRetirementAdvisoryServiceClient ? (
            <a className={accountLinkClass} href={planningDetailsUrl(isCWV)}>
              {agreementName}
            </a>
          ) : (
            <div
              className={
                'account-name-no-link b-typography-sans-serif--headline--50 b-font-weight-bold b-color-text--set--navy'
              }>
              {agreementName}
            </div>
          )}
        </div>
        <div className="account-info-check-sum b-typography-sans-serif--caption--200 b-font-weight-light b-color-text--set--navy blocked_data">
          {agreementNumberDisplay}
        </div>
      </div>
    );
}

export default connect()(AccountInfo);
